<form #paymentPeriodRangeForm="ngForm" id="paymentPeriodRangeForm" validate>
  <h5> <b> <i translate> Period Filter </i> </b> </h5>
  <hr class="mb-5">

  <!-- Period Filter -->
  <div>
    <div class="p-fluid grid mt-3">
      <div class="flex-container full-width">
        <div class="p-field col-6 pr-4">
          <p-floatlabel>
            <input pInputText
                   #periodFrom="ngModel"
                   maxlength="7"
                   minlength="7"
                   name="periodFrom"
                   type="text"
                   [disabled]="!isNewPayment || paymentSavedOk"
                   [(ngModel)]="payment.periodFrom"
                   [pattern]="patternPeriod"
                   required
            />
            <label class="required" for="periodFrom" translate>From</label>
          </p-floatlabel>
          <small *ngIf="periodFrom.touched && periodFrom.errors?.required" class="text-danger" translate>
            Generic Errors.Required Period From
          </small>
          <small *ngIf="periodFrom?.dirty && periodFrom.errors?.pattern && !periodFrom.errors?.minlength" class="text-danger" translate>
            Generic Errors.Incorrect Period From
          </small>
        </div>
        <div class="p-field col-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6 pr-4">
          <p-floatlabel>
            <input pInputText
                   #periodTo="ngModel"
                   maxlength="7"
                   minlength="7"
                   name="periodTo"
                   type="text"
                   [disabled]="!isNewPayment || paymentSavedOk"
                   [(ngModel)]="payment.periodTo"
                   [pattern]="patternPeriod"
                   required
            />
            <label class="required" for="periodTo" translate>To2</label>
          </p-floatlabel>

          <small *ngIf="periodTo.touched && periodTo.errors?.required" class="text-danger" translate>
            Generic Errors.Required Period To
          </small>

          <small *ngIf="periodTo?.dirty && periodTo.errors?.pattern && !periodTo.errors?.minlength" class="text-danger" translate>
            Generic Errors.Incorrect Period To
          </small>

          <small *ngIf="payment.periodFrom > payment.periodTo && !periodTo.errors?.required" class="text-danger" translate>
            Generic Errors.Greater Period From
          </small>
        </div>
      </div>
    </div>
  </div>
</form>
